"use client";

import { cn } from "@/lib/cn";

export function TextField({ className, ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className={cn(
        "h-10 w-full rounded-xl border border-(--border) bg-(--surface) px-3 text-sm text-(--text) shadow-sm placeholder:text-(--muted) focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:outline-none",
        className,
      )}
    />
  );
}
